import i18n from '@/i18n'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/guidance/')({
  loader: async () => {
    await i18n.loadNamespaces('billing')
    return
  },
})
